/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
export const selectionEventTypes = {
	SET: 'set',
	ADD: 'add',
	TOGGLE: 'toggle',
	REMOVE: 'remove',
	COMPOSITE: 'composite',
	SELECT_ALL: 'select_all',
};

export const expandEventTypes = {
	EXPAND_ALL: 'expand_all',
	EXPAND: 'expand',
	COLLAPSE: 'collapse',
	TOGGLE: 'toggle',
};

export const activeEventTypes = {
	ABSOLUTE: 'absolute',
	UP: 'up',
	DOWN: 'down',
};
